var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeavySnow01 = function SvgHeavySnow01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.65,
    y1: 157.09,
    x2: 153.33,
    y2: 17.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 40.31,
    y1: 202.43,
    x2: 194.29,
    y2: 63.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 52.64,
    y1: 216.07,
    x2: 206.61,
    y2: 76.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 70.41,
    y1: 235.75,
    x2: 224.39,
    y2: 96.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 68.78,
    y1: 233.94,
    x2: 222.75,
    y2: 94.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 29.14,
    y1: 190.07,
    x2: 183.12,
    y2: 50.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 37.12,
    y1: 198.9,
    x2: 191.1,
    y2: 59.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 16.66,
    y1: 176.25,
    x2: 170.63,
    y2: 37.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 7.97,
    y1: 166.63,
    x2: 161.94,
    y2: 27.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 56.89,
    y1: 220.79,
    x2: 210.87,
    y2: 81.68,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M144.75,24.72c-2.75,0-5.56.37-8.53,1.13C128.98,10.05,113.48,0,95.98,0,76.6,0,59.61,12.4,53.7,30.86c-.54,1.67.38,3.46,2.05,3.99,1.68.54,3.46-.38,3.99-2.05,5.06-15.82,19.63-26.45,36.24-26.45,14.76,0,27.86,8.36,34.19,21.55-4.36,1.99-7.37,4.93-9.22,7.28-1.08,1.38-.85,3.37.53,4.46.58.46,1.27.68,1.96.68.94,0,1.87-.42,2.49-1.21,1.72-2.18,4.73-5.06,9.34-6.38.02,0,.09-.02.11-.03,3.38-1.1,6.45-1.64,9.37-1.64,16.77,0,30.41,13.64,30.41,30.42s-13.64,30.41-30.41,30.41H47.74c-12.63,0-22.91-10.28-22.91-22.91s10.28-22.91,22.91-22.91c1.87,0,3.82.3,6.13.95,3.04.92,5.86,2.56,7.94,4.63.62.62,1.43.92,2.24.92s1.63-.31,2.25-.94c1.24-1.24,1.23-3.25-.01-4.49-2.81-2.8-6.58-5.01-10.61-6.22-.01,0-.02,0-.03,0,0,0-.02-.01-.03-.01-2.91-.82-5.41-1.2-7.88-1.2-16.13,0-29.26,13.12-29.26,29.26s13.12,29.25,29.26,29.25h97.01c20.27,0,36.76-16.49,36.76-36.76,0-20.27-16.49-36.76-36.76-36.76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.26,119.39c-.59-1.02-1.89-1.37-2.9-.78l-5.91,3.41,1.24-4.62c.3-1.13-.37-2.3-1.5-2.6-1.14-.29-2.3.37-2.6,1.5l-2.34,8.73-4.55,2.63c-1.16-1.21-2.65-2.08-4.33-2.5v-5.17l6.39-6.39c.83-.83.83-2.18,0-3.01s-2.18-.83-3.01,0l-3.38,3.38v-6.91c0-1.17-.95-2.13-2.13-2.13s-2.13.95-2.13,2.13v6.9l-3.38-3.38c-.83-.83-2.18-.83-3.01,0-.83.83-.83,2.18,0,3.01l6.39,6.39v5.17c-1.68.41-3.17,1.29-4.34,2.5l-4.47-2.58-2.34-8.73c-.3-1.13-1.47-1.8-2.61-1.5-1.13.3-1.81,1.47-1.5,2.6l1.24,4.62-5.99-3.46c-1.01-.59-2.32-.24-2.9.78-.59,1.02-.24,2.32.78,2.9l5.98,3.45-4.62,1.24c-1.13.3-1.81,1.47-1.5,2.6.26.95,1.11,1.58,2.05,1.58.18,0,.37-.02.55-.07l8.73-2.34,4.5,2.6c-.23.8-.4,1.63-.4,2.5s.16,1.69.39,2.48l-4.48,2.59-8.73-2.34c-1.14-.29-2.3.37-2.6,1.5-.3,1.13.37,2.3,1.5,2.6l4.62,1.24-5.99,3.46c-1.02.59-1.36,1.89-.78,2.9.59,1.02,1.89,1.36,2.9.78l5.98-3.45-1.24,4.62c-.3,1.14.37,2.3,1.5,2.61,1.16.3,2.31-.39,2.6-1.5l2.34-8.73,4.47-2.58c1.16,1.21,2.66,2.09,4.34,2.5v5.24l-6.39,6.39c-.83.83-.83,2.18,0,3.01.83.83,2.18.83,3.01,0l3.38-3.38v6.84c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-6.82l3.38,3.38c.83.83,2.18.83,3.01,0,.83-.83.83-2.18,0-3.01l-6.39-6.39v-5.25c1.68-.41,3.18-1.29,4.34-2.5l4.53,2.62,2.34,8.73c.3,1.11,1.44,1.81,2.61,1.5,1.13-.3,1.81-1.47,1.5-2.6l-1.24-4.62,5.92,3.42c1.01.59,2.32.24,2.9-.78.59-1.02.24-2.32-.78-2.9l-5.91-3.41,4.62-1.24c1.13-.3,1.81-1.47,1.5-2.6-.3-1.13-1.46-1.8-2.61-1.5l-8.73,2.34-4.56-2.63c.23-.79.39-1.62.39-2.48s-.16-1.7-.4-2.5l4.55-2.63,8.73,2.34c.19.05.37.07.55.07.94,0,1.8-.63,2.05-1.58.3-1.13-.37-2.3-1.5-2.6l-4.62-1.24,5.92-3.42c1.02-.59,1.36-1.89.78-2.9M116.23,138.56c-2.59,0-4.7-2.11-4.7-4.71s2.11-4.72,4.7-4.72,4.72,2.12,4.72,4.72-2.12,4.71-4.72,4.71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.2,119.31c-1.17,0-2.13.95-2.13,2.13v7.57c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.26,148.67c-1.17,0-2.13.95-2.13,2.13v7.57c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M135.53,167.73c-1.17,0-2.13.95-2.13,2.13v7.57c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M75.62,142.17c-1.17,0-2.13.95-2.13,2.13v7.57c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M55.78,176.12c-1.17,0-2.13.95-2.13,2.13v7.57c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.74,149.48c-1.17,0-2.13.95-2.13,2.13v7.57c0,1.17.95,2.13,2.13,2.13s2.13-.95,2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54.93,138.43c1.33,0,2.42-1.08,2.42-2.42v-8.48l8.49,4.9c1.15.67,2.64.27,3.3-.88.67-1.16.27-2.63-.88-3.3l-8.49-4.9,7.34-4.24c1.16-.67,1.55-2.15.88-3.3-.67-1.16-2.15-1.55-3.3-.89l-7.34,4.24v-9.8c0-1.33-1.08-2.42-2.42-2.42s-2.42,1.08-2.42,2.42v9.8l-7.34-4.24c-1.15-.67-2.63-.27-3.3.89-.67,1.16-.27,2.63.88,3.3l7.34,4.24-8.49,4.9c-1.16.67-1.55,2.15-.88,3.3.67,1.16,2.15,1.55,3.3.88l8.49-4.9v8.48c0,1.34,1.08,2.42,2.42,2.42Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.66,200c1.33,0,2.42-1.08,2.42-2.42v-8.48l8.49,4.9c1.15.67,2.64.27,3.3-.88.67-1.16.27-2.63-.88-3.3l-8.49-4.9,7.34-4.24c1.16-.67,1.55-2.15.88-3.3-.67-1.16-2.15-1.55-3.3-.89l-7.34,4.24v-9.8c0-1.33-1.08-2.42-2.42-2.42s-2.42,1.08-2.42,2.42v9.8l-7.34-4.24c-1.15-.67-2.63-.27-3.3.89-.67,1.16-.27,2.63.88,3.3l7.34,4.24-8.49,4.9c-1.16.67-1.55,2.15-.88,3.3.67,1.16,2.15,1.55,3.3.88l8.49-4.9v8.48c0,1.34,1.08,2.42,2.42,2.42Z"
  })));
};
export default SvgHeavySnow01;